const types = {
    SAVE_WORKOUTS_LIST: 'WO/ SET_LIST',
    ADD_WORKOUTS_LIST: 'WO/ ADD_LIST',
    CLEAR_WORKOUTS_LIST: 'WO/ CLEAR_LIST',
    SET_IS_LOADING: 'WO/ SET_IS_LOADING',
}

export default types